var exports = {
  "kL": "ProfileTypeSelector.module__container___Nm1zSn",
  "r9": "ProfileTypeSelector.module__disabled___Nm1zSn",
  "h_": "ProfileTypeSelector.module__description___Nm1zSn",
  "By": "ProfileTypeSelector.module__guildOption___Nm1zSn",
  "mN": "ProfileTypeSelector.module__guildOptionGlobal___Nm1zSn",
  "XN": "ProfileTypeSelector.module__guildAvatar___Nm1zSn",
  "oM": "ProfileTypeSelector.module__guildAvatarPlaceholder___Nm1zSn",
  "p2": "ProfileTypeSelector.module__guildOptionLabel___Nm1zSn",
};

module.exports = exports;
